export const ProductImages = [
  require('./RoverImages/LandRover.PNG'),
  require('./RoverImages/LandRover.PNG'),
  require('./RoverImages/LandRover.PNG'),
  require('./RoverImages/LandRover.PNG'),
  require('./RoverImages/LandRover.PNG'),
  require('./RoverImages/LandRover.PNG'),
];
